'use client';

import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui';

export default function Error({ error, reset }: { error: Error; reset: () => void }) {
  const t = useTranslations('errors');

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-zen-app px-6 text-zen-text">
      <h1 className="text-2xl font-semibold">{t('serverError.title')}</h1>
      <p className="max-w-lg text-center text-sm text-zen-text-muted">
        {error?.message || t('serverError.description')}
      </p>
      <Button type="button" variant="outline" className="rounded-full" onClick={reset}>
        {t('serverError.retry')}
      </Button>
    </div>
  );
}
